import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';
import _ from 'lodash';
import VueUsuariosList from './components/lists/usuarios.vue';
import VueUnidadesList from './components/lists/unidades.vue';
import VueCentrosList from './components/lists/centros.vue';
import VueEditalsList from './components/lists/editals.vue';
import VueAtuacaosList from "./components/lists/atuacaos.vue";
import VueProjetosList from './components/lists/projetos.vue';
import VueMensagemsList from './components/lists/mensagems.vue';
import VueAvalItensList from './components/lists/aval-itens.vue';
import VueUsuarioForm from './components/forms/usuario.vue';
import VueUnidadeForm from './components/forms/unidade.vue';
import VueCentroForm from './components/forms/centro.vue';
import VueDadosForm from './components/forms/dados.vue';
import VueEditalForm from './components/forms/edital.vue';
import VueProjetoForm from './components/forms/projeto.vue';
import VueMensagemForm from './components/forms/mensagem.vue';
import VueAvalItemForm from './components/forms/aval-item.vue';
import VueAvalProdSiacItemForm from './components/forms/aval-prod-siac-item.vue';
import VueAvalFormItemForm from './components/forms/aval-form-item.vue';
import VueAvalRelItemForm from './components/forms/aval-rel-item.vue';
import VueAvalPesoForm from './components/forms/aval-peso.vue';
import VueAvalNotaMaximaForm from './components/forms/aval-nota-maxima.vue';
import VueAvalSubgrupoForm from './components/forms/aval-subgrupo.vue';
import VueAtuacaoForm from "./components/forms/atuacao.vue";
import VueProjetosVisualizar from "./components/visualizar/projetos.vue";
import VueDashboard from "./components/lists/dashboard.vue";
import VuePertinenciaList from "./components/lists/pertinencia.vue";
import VuePertinenciaAvalList from "./components/lists/pertinencia-aval.vue";
import VuePertinenciaForm from "./components/forms/pertinencia.vue";
import VueRecursoForm from "./components/forms/recurso.vue";
import VueRecursosList from "./components/lists/recursos.vue";
import VueRecursosAvalPertForm from "./components/forms/recursos-aval-pert.vue";
import VueRecursosAvalAvalForm from "./components/forms/recursos-aval-aval.vue";
import VueRecursosAvalList from "./components/lists/recursos-aval.vue";
import VueAvaliacaosList from "./components/lists/avaliacaos.vue";
import VueAvaliacaosAvalList from "./components/lists/avaliacaos-aval.vue";
import VueAvaliacaosTodasList from "./components/lists/avaliacaos-todas.vue";
import VueAvaliacaoForm from "./components/forms/avaliacao.vue";
import VueJustificativasList from './components/lists/justificativas.vue';
import VueRelatoriosBolsasList from './components/lists/relatorios-bolsas.vue';
import VueRelatorioBolsaForm from './components/forms/relatorio-bolsa.vue';
import VueBolsasDistribuicaoList from './components/lists/bolsas-distribuicao.vue';
import VueBolsasAtribuicaoList from './components/lists/bolsas-atribuicao.vue';
import VueBolsaAtribuicaoForm from './components/forms/bolsa-atribuicao.vue';
import VueBolsaRemocaoForm from './components/forms/bolsa-remocao.vue';
import VueVoluntariosAtribuicaoList from './components/lists/voluntarios-atribuicao.vue';
import VueVoluntarioAtribuicaoForm from './components/forms/voluntario-atribuicao.vue';
import VueRelatoriosVoluntariosList from './components/lists/relatorios-voluntarios.vue';
import VueConfiguracaoAnaliseTecnica from './components/forms/analise_tecnica/configuracao/configuracao_analise_tecnica.vue';
import VueConfiguracaoInscricao from './components/forms/inscricao/configuracao/configuracao_inscricao.vue';
import VueConfiguracaoFaixas from './components/forms/configuracao_faixas.vue';
import VueInscricoesList from './components/lists/inscricaos.vue';
import VueInscricaoForm from './components/forms/inscricao/create_or_update.vue';
import VueAnalisesTecnicasList from './components/lists/analises-tecnicas.vue';
import VueAnaliseTecnicaForm from './components/forms/analise_tecnica/create_or_update.vue';
import VueConfiguracaoAvaliacao from './components/forms/nova_avaliacao/configuracao/configuracao_avaliacao.vue';
import VueNovaAvaliacaoForm from './components/forms/nova_avaliacao/realizar_avaliacao.vue';
import LogList from './components/LogList.vue';
import {store} from './store.js';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';
import AsyncComputed from 'vue-async-computed';
M.AutoInit();
window.Swal = require('sweetalert2');

$(document).ready(function(){


  $('.materialize-select').formSelect();
  $('.parallax').parallax();
  $('.modal').modal();
  $('.collapsible').collapsible();

  var elem = document.querySelector('.collapsible.expandable');
  var instance = M.Collapsible.init(elem, {
    accordion: false
  });

});

Vue.prototype.$http = axios

Vue.use(VueResource);
Vue.use(VueTheMask);
Vue.use(AsyncComputed);

new Vue({
  el: '#container',
  store,
  components: {
    VueUsuariosList,
    VueUnidadesList,
    VueCentrosList,
    VueEditalsList,
    VueAtuacaosList,
    VueProjetosList,
	VueMensagemsList,
	VueAvalItensList,
    VueUsuarioForm,
    VueUnidadeForm,
    VueCentroForm,
    VueDadosForm,
    VueEditalForm,
    VueProjetoForm,
	VueMensagemForm,
	VueAvalItemForm,
	VueAvalProdSiacItemForm,
	VueAvalFormItemForm,
	VueAvalRelItemForm,
	VueAvalPesoForm,
	VueAvalNotaMaximaForm,
	VueAvalSubgrupoForm,
    VueAtuacaoForm,
    VueProjetosVisualizar,
    VueDashboard,
    VuePertinenciaList,
    VuePertinenciaAvalList,
    VuePertinenciaForm,
	VueRecursoForm,
	VueRecursosList,
	VueRecursosAvalPertForm,
	VueRecursosAvalAvalForm,
	VueRecursosAvalList,
	VueAvaliacaosList,
	VueAvaliacaosAvalList,
	VueAvaliacaosTodasList,
	VueAvaliacaoForm,
	VueJustificativasList,
	VueRelatoriosBolsasList,
	VueRelatorioBolsaForm,
	VueBolsasDistribuicaoList,
	VueBolsasAtribuicaoList,
	VueBolsaAtribuicaoForm,
	VueBolsaRemocaoForm,
	VueVoluntariosAtribuicaoList,
	VueVoluntarioAtribuicaoForm,
	VueRelatoriosVoluntariosList,
	VueConfiguracaoAnaliseTecnica,
	VueConfiguracaoInscricao,
	VueConfiguracaoFaixas,
	VueInscricoesList,
	VueInscricaoForm,
	VueAnalisesTecnicasList,
	VueAnaliseTecnicaForm,
    VueConfiguracaoAvaliacao,
    VueNovaAvaliacaoForm,
    LogList,
  },
})


